



































import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import BaseModel from "@/models/base/BaseModel.model";
import HttpClient from "@/core/HttpResources/BaseHttpClient";
import ApiQueryOption from "@/models/base/ApiQueryOption.model";
import { Utils } from "@/core/Utils";

@Component({})
export default class UsuarioCarta extends Vue {
  @Prop() public action!: string;
  @Prop() public controller!: string;
  @Prop() public whereParams!: string;
  @Prop() public include!: string;
  @Prop() public value!: number | any;
  @Prop() public cedula!: string;
  @Prop() public closable!: boolean;
  @Prop() public closeTitle!: string;
  loading = false;
  isImageModalActive = false;

  usuario = null;
  client = new HttpClient(this.controller || "usuario");

  get isCosable() {
    return this.closable === false ? false : true;
  }
  queryParams(): ApiQueryOption {
    let instace = new ApiQueryOption();
    instace.where = this.whereParams;
    instace.include = this.include;
    if (instace.where) {
      if (this.cedula) {
        let ced = this.cedula.replace(/-/g, "");
        instace.where += `cedula="${ced}"`;
      } 
    } else {
      if (this.cedula) {
        let ced = this.cedula.replace(/-/g, "");
        instace.where = `cedula="${ced}"`;
      } 
    }

    if (!instace.include) delete instace.include;
    return instace;
  }
  get isId() {
    return !isNaN(this.value);
  }

  async getDataAsync() {
    try {
      this.loading = true;
      let resource = this.action || String();
      if (this.value && this.isId) {
        resource += `${this.value}`;
      }
      let result = await this.client.getAsync<any>(
        resource,
        this.queryParams()
      );

      if (resource) {
        this.usuario = result;
        this.$emit("input", result ? result.id : null);
      } else {
        this.usuario = result[0];
        this.$emit("input", this.usuario);
      }

      this.$emit("change", this.usuario);
    } catch (e) {
      this.usuario = null;
      this.$emit("change", null);
    } finally {
      this.loading = false;
    }
  }

  getFoto(value: string) {
    return `data:image/jpg;base64, ${value}`;
  }
  @Watch("value", { deep: true, immediate: true })
  OnValueChange(value: any) {
    if (!value) {
      this.usuario = null;
      return;
    }
    if (isNaN(value)) {
      this.usuario = this.value;
      this.$emit("change", value);
    } else {
      this.getDataAsync();
    }
  }
  @Watch("cedula")
  onCedula(value: any) {
    if (!value) {
      this.usuario = null;
      return;
    }
    this.getDataAsync();
  }
  close() {
    this.usuario = null;
    this.$emit("close", null);
    this.$emit("input", null);
  }
}
